import React from 'react';
import { CountryCode, TranslationKey, TransObject } from '@dayetopia/library/types';
import useTranslate from '@hooks/useTranslate';
import TransHTML from './TransHTML';

type Props = {
  country?: CountryCode;
  transKey: TranslationKey;
  transObject?: TransObject;
};

const Trans: React.FC<Props> = ({ country, transKey, transObject }) => {
  const { t } = useTranslate(country);

  const replacedText = t(transKey, transObject);

  return <TransHTML>{replacedText}</TransHTML>;
};

export default Trans;
